import React from "react";
import { cn } from "@/lib/utils";

const CONFIG = {
  // Client
  Lead: "bg-muted text-muted-foreground",
  "Proposal Sent": "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  Negotiation: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  Active: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  "On Hold": "bg-orange-500/10 text-orange-600 dark:text-orange-400",
  Completed: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  Lost: "bg-red-500/10 text-red-600 dark:text-red-400",
  Inactive: "bg-muted text-muted-foreground",
  // Task
  Backlog: "bg-muted text-muted-foreground",
  "To Do": "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  "In Progress": "bg-primary/15 text-primary",
  Blocked: "bg-red-500/10 text-red-600 dark:text-red-400",
  "Internal Review": "bg-purple-500/10 text-purple-600 dark:text-purple-400",
  "Client Approval": "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  Revision: "bg-orange-500/10 text-orange-600 dark:text-orange-400",
  Cancelled: "bg-muted text-muted-foreground",
  // Project
  Planning: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  "Not Started": "bg-muted text-muted-foreground",
  "Under Review": "bg-purple-500/10 text-purple-600 dark:text-purple-400",
  // Deliverable / approval
  Pending: "bg-muted text-muted-foreground",
  "Sent to Client": "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  Approved: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  // Quotation
  Draft: "bg-muted text-muted-foreground",
  Sent: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  Viewed: "bg-indigo-500/10 text-indigo-600 dark:text-indigo-400",
  Accepted: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  Rejected: "bg-red-500/10 text-red-600 dark:text-red-400",
  Expired: "bg-muted text-muted-foreground",
  // Priority
  Low: "bg-muted text-muted-foreground",
  Medium: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  High: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  Urgent: "bg-red-500/10 text-red-600 dark:text-red-400",
  // Workload
  Available: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  Normal: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  Busy: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  Overloaded: "bg-red-500/10 text-red-600 dark:text-red-400",
};

export default function StatusBadge({ value, className }) {
  const cls = CONFIG[value] || "bg-muted text-muted-foreground";
  return (
    <span
      data-testid={`status-${(value || "").toString().toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center h-6 px-2 rounded font-mono text-[10px] font-semibold uppercase tracking-[0.1em] whitespace-nowrap",
        cls,
        className
      )}
    >
      {value || "—"}
    </span>
  );
}
